import {translations} from 'presentation/translations-new';
import {ServiceIconEnum, ServiceInfo, ServiceMap} from '../constants/constants';
import {HealthGuideServicesTypeEnum} from 'presentation/constants';

const {healthServicesNames} = translations['pt-br'].privateFlow.guideFlow.guideDetails;

export function getServiceInfo(
	serviceName: string,
	isSemanticSearchEnabled?: boolean,
): ServiceInfo {
	if (
		isSemanticSearchEnabled &&
		serviceName.toUpperCase() === HealthGuideServicesTypeEnum.AUXILIARY_SERVICES
	) {
		return {
			icon: ServiceIconEnum.AUXILIARY_DIAGNOSTIC_AND_THERAPY_SERVICES,
			label: healthServicesNames.examsProceduresAndTherapies,
		};
	}
	return (
		ServiceMap[serviceName.toUpperCase()] ?? {
			icon: ServiceIconEnum.DOCTORS_OFFICES_AND_CLINICS,
			label: healthServicesNames.doctorsOfficesAndClinics,
		}
	);
}
